module.exports = __webpack_public_path__ + "static/media/react.43e8bef1.png";